import styles from './index.less';

const imgUrl = require('@/assets/images/order/loding.png');

const Loading = () => {
  return (
    <div
      className={styles.loading}
      style={{
        backgroundImage: `url(${imgUrl})`,
        width: '0.8rem',
        height: '0.76rem',
        position: 'fixed',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%,-50%)',
        WebkitTransform: 'translate(-50%,-50%)',
      }}
    ></div>
  );
};

export default Loading;
